import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyApproverSelectionPage = lazyWithRetry(
  () => import("./ApproverSelectionPage"),
);

const ApproverSelectionPage = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyApproverSelectionPage {...props} />;

export default ApproverSelectionPage;
